import React, { Component } from "react";
import InlineSVG from "svg-inline-react";
import "./index.css";
import CloseImage from "./icons/CloseImage";
import { actions as notifActions } from "redux-notifications";
import { push } from "redux-little-router";
import ProfilePicture from "../ProfilePicture";

const { notifDismiss } = notifActions;

class AlertComponent extends Component {
  constructor(props) {
    super(props);
    this.classNames = {
      info: "info",
      error: "error",
      success: "success",
      notification: "notification",
    };
    this.dismissNotification = this.dismissNotification.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.handleNotificationImageClick = this.handleNotificationImageClick.bind(this);
  }
  dismissNotification() {
    const { dispatch, id } = this.props;
    dispatch(notifDismiss(id));
  }
  handleNotificationClick(path) {
    const { dispatch } = this.props;
    return e => {
      dispatch(push(path));
      this.dismissNotification();
      e.stopPropagation();
    };
  }
  handleNotificationImageClick(path) {
    const { dispatch } = this.props;
    return e => {
      dispatch(push(path));
      e.stopPropagation();
      this.dismissNotification();
    };
  }
  render() {
    const { message, kind: type, notifications, id } = this.props;
    if (type === "notification") {
      let notificationData = notifications.find(notification => notification.id === id);
      const { path, actor: { path: actorPath, picture, actorId } } = notificationData;
      return (
        <div className={`alert-container  ${this.classNames[type]}`} onClick={this.handleNotificationClick(path)}>
          <span className="-close" onClick={this.dismissNotification}>
            <InlineSVG src={CloseImage} />
          </span>
          <div className="-image" onClick={this.handleNotificationImageClick(actorPath)}>
            <ProfilePicture userId={actorId} size="s" fallbackUrl={picture} alt="avatar" />
          </div>
          <div className="-data">{message}</div>
        </div>
      );
    }
    return (
      <div className={`alert-container ${this.classNames[type]}`}>
        <a className="-close" onClick={this.dismissNotification}>
          <InlineSVG src={CloseImage} alt="icon" />
        </a>
        <div className="-image" />
        <div className="-data">{message}</div>
      </div>
    );
  }
}

export default AlertComponent;



// WEBPACK FOOTER //
// ./src/components/AlertComponent/index.js